import { render, staticRenderFns } from "./character.vue?vue&type=template&id=703a34a6&scoped=true"
var script = {}
import style0 from "./character.vue?vue&type=style&index=0&id=703a34a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a34a6",
  null
  
)

export default component.exports